<div class="sidebar">
  <div class="content">
    <div class="top-box">
      <div class="img">
        <div class="flex justify-content-start flex-wrap">
          <div class="flex align-items-center justify-content-center">
            <img style="width: 122px; " src="assets/image/auto-e-care-logo.png" alt="Logo" class="svg-black" />
          </div>
          <!-- <div class="flex align-items-center justify-content-center ml-2">
            <p style="color: #1d2939; font-weight: 700; font-size: 16px">
              Auto <span style="color: #F4B401;">E</span> Care
            </p>
          </div> -->
        </div>
      </div>
      <nav class="menu">
        <ul>
          <li class="menu-item" style="cursor: pointer" [routerLink]="['/', basePath, 'user-dashboard']"
            (click)="setActiveMenu('user-dashboard')">
            <a [ngClass]="{ active: activeMenu === 'user-dashboard' }" routerLinkActive="active">
              <i class="icon pi pi-th-large"></i> Dashboard
            </a>
          </li>
          <!-- Distributor -->
          <app-permission-wrapper permission="CanViewDistributor">
            <li class="menu-item" [routerLink]="['/', basePath, 'distributor-partners']"
              (click)="setActiveMenu('service-distributor')">
              <a [ngClass]="{ active: activeMenu === 'service-distributor' }" routerLinkActive="active"
                style="cursor: pointer;">
                <i class="icon pi pi-users"></i> Distributor Partners
              </a>
            </li>
          </app-permission-wrapper>
          <!-- Providers -->
          <app-permission-wrapper permission="CanViewServiceProvider">
            <li class="menu-item" [routerLink]="['/', basePath, 'vehicle-service-provider']"
              (click)="setActiveMenu('serviceProviders')">
              <a [ngClass]="{ active: activeMenu === 'serviceProviders' }" routerLinkActive="active"
                style="cursor: pointer;">
                <i class="icon pi pi-users"></i> Vehicle Service Providers
              </a>
            </li>
          </app-permission-wrapper>
          <!--Advisors  -->
          <app-permission-wrapper permission="CanViewTechnicalAdvisor">
            <li class="menu-item" [routerLink]="['/', basePath, 'technical-advisors']"
              (click)="setActiveMenu('service-advisors')">
              <a [ngClass]="{ active: activeMenu === 'service-advisors' }" routerLinkActive="active"
                style="cursor: pointer;">
                <i class="icon pi pi-users"></i> Technical Advisors
              </a>
            </li>
          </app-permission-wrapper>
          <!-- seekers/customers -->
          <app-permission-wrapper permission="CanViewServiceSeeker">
            <li class="menu-item" [routerLink]="['/', basePath, 'vehicle-owners']" (click)="setActiveMenu('customers')">
              <a [ngClass]="{ active: activeMenu === 'customers' }" routerLinkActive="active" style="cursor: pointer;">
                <i class="icon pi pi-users"></i> Vehicle Owners
              </a>
            </li>
          </app-permission-wrapper>
          <!-- wallet -->
          <!-- <li class="menu-item" [routerLink]="['/', basePath, 'invoicing']" (click)="setActiveMenu('invoicing')"
            style="cursor: pointer">
            <a [ngClass]="{ active: activeMenu === 'invoicing' }" routerLinkActive="active">
              <i class="icon pi pi-file-plus"></i> Invoicing
            </a>
          </li> -->
          <!-- Locker -->
          <li class="menu-item" style="cursor: pointer" [routerLink]="['/', basePath, 'locker']"
            (click)="setActiveMenu('locker')">
            <a [ngClass]="{ active: activeMenu === 'locker' }" routerLinkActive="active">
              <i class="icon pi pi-inbox"></i> E Locker
            </a>
          </li>
          <!-- Promotions -->
          <app-permission-wrapper permission="CanViewPromotions">
            <li class="menu-item" style="cursor: pointer" [routerLink]="['/', basePath, 'promotion']"
              (click)="setActiveMenu('promotions')">
              <a [ngClass]="{ active: activeMenu === 'promotions' }" routerLinkActive="active">
                <i class="icon pi pi-inbox"></i>Promotions
              </a>
            </li>
          </app-permission-wrapper>
          <!-- wallet -->
          <li class="menu-item" style="cursor: pointer" [routerLink]="['/', basePath, 'wallet']" *ngIf="role!==3">
            <a [ngClass]="{ active: activeMenu === 'wallet' }" routerLinkActive="active">
              <i class="icon pi pi-credit-card"></i> Wallet
            </a>
          </li>

          <app-permission-wrapper permission="CanManageRoles">
            <li class="menu-item" style="cursor: pointer" [routerLink]="['/', basePath, 'role-permission']"
              (click)="setActiveMenu('role-permission')">
              <a [ngClass]="{ active: activeMenu === 'role-permission' }" routerLinkActive="active">
                <i class="icon pi pi-cog"></i> Roles and Permission
              </a>
            </li>
          </app-permission-wrapper>
         
          <!-- customer support -->
          <li *ngIf="userRole === 0 || userRole === 4 || (userRole === 3 && (creatorUserAccesType === 0 || creatorUserAccesType === 4))" 
           class="menu-item" style="cursor: pointer" [routerLink]="['/', basePath, 'support']"
            (click)="setActiveMenu('support')">
            <a [ngClass]="{ active: activeMenu === 'support' }" routerLinkActive="active">
              <i class="icon pi pi-headphones"></i> Suport
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <!-- bottom-menu -->
    <div class="bottom-menu" #logoutMenu>

      <ul *ngIf="showLogout">
        <li class="menu-item">
          <span routerLink="/profile" style="cursor: pointer; display: flex; align-items: center;">
            <i class="icon pi pi-user-edit m-2"></i> Profile
          </span>
        </li>
        <li class="menu-item1">
          <span (click)="confirm1($event)" style="cursor: pointer; display: flex; align-items: center;">
            <i class="icon pi pi-power-off m-2"></i> Log Out
          </span>
        </li>
      </ul>
      <div style="padding-bottom: 11px; margin-left: 10px; margin-right: 10px">
        <div class="bottom-box">
          <div class="user-info" (click)="toggleLogoutMenu($event)">
            <div class="icon-circle" style="cursor: pointer;">
              <img [src]="profilePhotoUrl" class="image" alt="{{initials}}" />
            </div>

            <div class="username ml-3">
              <p class="name" style="cursor: pointer;" [pTooltip]="name && name.length > 17 ? name : null"
                tooltipPosition="top">
                {{ name && name.length > 17 ? (name | slice:0:17) + '...' : name }}
              </p>
              <!-- <p class="email" style="cursor: pointer;" pTooltip="{{ email }}">
                {{ truncateEmail(email, 25) }}
              </p> -->
              <p class="email" style="cursor: pointer;" [pTooltip]="email && email.length > 20 ? email : null"
                [tooltipDisabled]="email && email.length <= 20"> {{ truncateEmail(email, 20) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>
<p-confirmDialog></p-confirmDialog>